import { UIAnalyticsEvent } from '@atlaskit/analytics-next';

import { PullRequestState } from 'src/components/types';

export const ANALYTICS_CHANNEL = 'editor';

export type CreateAnalyticsEvent = (event: object) => UIAnalyticsEvent;

export enum trackEventActions {
  created = 'created',
  updated = 'updated',
  deleted = 'deleted',
  resolved = 'resolved',
  reopened = 'reopened',
}

export enum actionSubjectIds {
  createCommentButton = 'createCommentButton',
  createCommentInput = 'createCommentInput',
  editButton = 'editButton',
  cancelFailedRequestButton = 'cancelFailedRequestButton',
  retryFailedRequestButton = 'retryFailedRequestButton',
  deleteButton = 'deleteButton',
  saveButton = 'saveButton',
  cancelButton = 'cancelButton',
  replyButton = 'replyButton',
  resolveButton = 'resolveButton',
  reopenButton = 'reopenButton',
  autoreviewThumbsUp = 'autoreviewThumbsUp',
  autoreviewThumbsDown = 'autoreviewThumbsDown',
  autoreviewTextFeedbackSubmission = 'autoreviewTextFeedbackSubmission',
}

export enum eventTypes {
  UI = 'ui',
  TRACK = 'track',
}

export interface AnalyticsEvent {
  update: (attributes: object) => void;
  fire: (channel: string) => void;
  attributes: object;
}

export type AutoreviewFeedbackSentiment = 'positive' | 'negative' | 'neutral';

export type EventAttributes = {
  nestedDepth?: number;
  resolved?: boolean;
  prStatus?: PullRequestState;
  paid?: boolean;
  prId?: number;
  repoId?: string;
  role?: string;
  pending?: boolean;
  activityFeedVersion?: string;
  isAutoreview?: boolean;
  autoreviewFeedbackSentiment?: AutoreviewFeedbackSentiment;
  autoreviewTextFeedback?: string;
  prURL?: string;
  prAuthorId?: string;
  commentId?: number;
};

export type EventData = {
  actionSubjectId?: string;
  objectId?: string;
  containerId?: string;
  nestedDepth?: number;
  eventType?: eventTypes;
  action?: string;
  actionSubject?: string;
  attributes?: EventAttributes;
};

export function fireEvent(
  analyticsEvent: UIAnalyticsEvent,
  eventData: EventData
) {
  analyticsEvent.update({
    ...eventData,
    eventType: eventData.eventType || eventTypes.UI,
    attributes: {
      ...analyticsEvent,
      ...eventData.attributes,
    },
  });
  analyticsEvent.fire(ANALYTICS_CHANNEL);
}
